import React, { forwardRef } from 'react'
import { IconClose } from '../icon/icon'
import { ErrorReference } from './error-reference'

// The failure alert: a failed request's message and its reference
// (error-reference.js), dismissable. The layout's exception alert (FormSimple,
// the grids) and a Form's or FormNew's failed save (save-failure.js) show it.
export const ErrorAlert = forwardRef(({ message, error, onClose, className }, ref) =>
  <div ref={ref} className={['alert alert-danger err-alert', className].filter(Boolean).join(' ')} role="alert">
    <div className="d-flex gap-2">
      <div className="flex-fill">{message}</div>
      {onClose &&
        <button type="button" className="btn p-0 border-0 text-reset lh-1 align-self-start" aria-label="Dismiss" onClick={onClose}>
          <IconClose />
        </button>}
    </div>
    {/* Under the message row, the full width: a whole request id fits at 390 px. */}
    <ErrorReference error={error} />
  </div>
)
